import styled from 'styled-components';


const FooterSidebarWrapper = styled.div`
  .btn-get-more {
    height: auto !important;
  }
  .ant-divider {
    margin-top: 12px;
    margin-bottom: 12px;
  }
`;

export default FooterSidebarWrapper;

export const UserSettingStyles = styled.div`
  .avatar-wrap {
    transition: all 1s linear;
    &:hover {
      .avatar-caret {
        transform: rotate(180deg);
      }
    }
  }
  .ant-avatar {
    background-color: #8F40A3;
    font-size: 12px !important;
    font-weight: 400;
    color: white;
  }
  
  .avatar-caret {
    font-size: 11px;
    color: #CCD2DA;
    margin-left: 8px;
  }
  .bell-icon {
    font-size: 22px;
    color: #737373;
    margin-right: 14px;
  }
  .help-wrap {
    padding: 5px 10px;
    background: #F0F1F3;
    border-radius: 7px;
    font-size: 11px;
    color: #53575D;
    display: flex;
    align-items: center;
    gap: 5px;

    &-text {
      font-weight: 600;
      margin: 0;
      line-height: 15px;
    }
  }
`
